(function () {
  'use strict';

  angular
    .module('web2print.message')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig ($stateProvider, $urlRouterProvider) {
    console.log('Message routes');
    $stateProvider
      .state('main.message', {
        url: '/message',
        templateUrl: 'components/message/message.html',
        controller: 'MessageController',
        controllerAs: 'message',
        onEnter: function () {
        }
      });
  }

})();
